import { useEffect, useState } from 'react';
import currency from 'currency.js';

import './style.scss';

const format = {
    precision: 2
};

const PriceText = ({
    price,
    discountedPrice = '',
    isDiscounted = false,
    ...rest
}) => {
    const [amount, setAmount] = useState('');
    const [discountedAmount, setDiscountedAmount] = useState('');

    useEffect(() => {
        let tmp = (currency(price).format(format)).replace(".00", '');
        setAmount(tmp);
    }, [price]);

    useEffect(() => {
        let tmp = (currency(discountedPrice).format(format)).replace(".00", '');
        setDiscountedAmount(tmp);
    }, [discountedPrice]);


    if (!!isDiscounted && price && parseFloat(price) > 0 && discountedPrice && parseFloat(discountedPrice) > 0) {
        return <span className='price-text' {...rest}><strike>{amount}</strike> <span className='price-text__discounted'>{discountedAmount}</span></span>;
    }

    return <span className='price-text'{...rest}>{amount}</span>;
};

export default PriceText;